import { z } from "zod/v4";

export const FileChangedPayloadSchema = z.object({
	path: z.string(),
	content: z.string(),
});

export type FileChangedPayload = z.infer<typeof FileChangedPayloadSchema>;
